<script>
    import {apiFetch} from '../../apiFetch';
    import ValidationsGraph from './ValidationsGraph.svelte';
    import Spinner from "../spinner/Spinner.svelte";

    export let campaignId;

    const fetchValidations = (async () => {
        const json = await apiFetch('/campaigns/' + campaignId + '/validations');

        let points = [];
        json.stats.validations.forEach((day) => {
            points.push({
                x: new Date(day.period),
                y: day.amount,
            });
        });

        return points;
    })();

</script>
{#await fetchValidations}
    <Spinner/>
{:then data}
    <ValidationsGraph points={data}/>
{:catch error}
    {@debug error}
    <p>An error occurred!</p>

{/await}